var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___cHF1cU",
  "h_": "KeyboardModeIntroModal.module__description___cHF1cU",
  "Xq": "KeyboardModeIntroModal.module__tips___cHF1cU",
  "uN": "KeyboardModeIntroModal.module__tip___cHF1cU",
  "HP": "KeyboardModeIntroModal.module__keys___cHF1cU",
  "eS": "KeyboardModeIntroModal.module__kbd___cHF1cU",
  "me": "KeyboardModeIntroModal.module__separator___cHF1cU",
  "xY": "KeyboardModeIntroModal.module__tipText___cHF1cU",
};

module.exports = exports;
